import 'reflect-metadata';
import {IsBoolean, IsDateString, IsEmail, IsEnum, IsNumber, IsString, Length, ValidateNested} from 'class-validator';
import {Expose, Type} from 'class-transformer';
import {ADMIN_ROLE, PROJECT_ADMIN_ROLE, RolesEnum} from '../AccessControl';
import {RolesType} from '../types';

class AccountDataClass {
  @IsNumber()
  @Expose()
  id: number;

  @IsString()
  @Length(0, 250)
  @Expose()
  firstName: string;

  @IsString()
  @Expose()
  lastName: string;

  @IsEmail()
  @Expose()
  emailAddress: string;

  @Expose()
  isEmailValidated: boolean;

  @Expose()
  @IsDateString()
  lastLoginDate: Date;

  @Expose()
  get isAdmin(): boolean {
    return [ADMIN_ROLE, PROJECT_ADMIN_ROLE].includes(this.role);
  }

  @Expose()
  @IsEnum(RolesEnum)
  role: string;

  @Expose()
  userRoles: IUserRoleAssignment[]
}

class CreateAccountDataClass {
  @IsString()
  @Expose()
  @Length(0, 250)
  firstName: string;

  @Expose()
  @IsString()
  lastName: string;

  @Expose()
  @IsEmail()
  emailAddress: string;

  @Expose()
  @IsBoolean()
  isActive: boolean;

  @Expose()
  @IsEnum(RolesEnum)
  role: RolesType = 'contractor';

  @Expose()
  @ValidateNested({each: true})
  @Type(() => AssignUserRoleDataClass)
  userRoles: IUserRoleAssignment[];
}

class AssignUserRoleDataClass implements IUserRoleAssignment {
  @Expose()
  @IsNumber()
  roleId: number;
}

interface IUserRoleAssignment {
  roleId: number;
}



class UpdateAccountDataClass extends CreateAccountDataClass {
  @IsNumber()
  @Expose()
  id: number;

}


export class Accounts {
  public static Endpoints = {
    BaseRoute: 'accounts'
  };

  public static AccountData = AccountDataClass;
  public static AssignUserRoleData = AssignUserRoleDataClass;
  public static UpdateAccountData = UpdateAccountDataClass;
  public static CreateUpdateAccountData = CreateAccountDataClass;
}